// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"dc59e42e","3544":"5f49adb8","7763":"32ae5203","8810":"bc8a8a01","8859":"1f2987e2"}[chunkId] + ".chunk.css";
};